define('shared/initializer/die',[
    'shared/lib/RSVP', 
    'shared/util/hub',
    'shared/util/dom/expression'
], 
function(
    RSVP, 
    hub,
    expression
) {
    'use strict';

    var PATH_HUB = 'components/pageProvider';

    return {
        init: function($el){
            return hub.get(PATH_HUB)
                .then(function(pageProvider){
                    return pageProvider.promise;
                })
                .then(function(){
                    return expression.enable($el);
                })
                .then(function(){
                    if ( $el.css('visibility') == 'hidden' ) {
                        $el.css({
                            'visibility':'',
                            'opacity': '0'
                        }).animate({
                            opacity: 1
                        });
                    }
                });
        }
    };
});

